import React from 'react';
import { Link } from 'react-router-dom';

interface LogoProps {
  className?: string;
  textClassName?: string;
}

const Logo: React.FC<LogoProps> = ({
  className = 'h-16 w-auto',
  textClassName = 'text-2xl font-bold text-white',
}) => {
  return (
    <Link to="/" className="flex-shrink-0 cursor-pointer">
      <img className={className} src="/logo.png" alt="VLSI Club Logo" />
      <div className={`hidden ${textClassName}`}>VLSI CLUB</div>
    </Link>
  );
};

export default Logo;
